function CalendarReminder() {
    this.button = document.querySelector(".button--reminder");
    if (this.button) {
        this.button.addEventListener("click", downloadReminder);
    }
    return;
}

function isSafariIOS() {
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    return iOSSafari;
}

function isIOS() {
    return (
        [
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
}

function pad(number) {
    if (number < 10) {
        return "0" + number;
    }
    return number;
}

function formatDateForIcs(d) {
    var str =
        d.getFullYear() +
        pad(d.getMonth() + 1) +
        pad(d.getDate()) +
        "T" +
        pad(d.getHours()) +
        pad(d.getMinutes()) +
        "00";
    return str;
}

function downloadReminder() {
    var hostname = location.hostname + ":" + location.port;
    var input = jQuery("#reminder-input");
    var input_message = document.getElementById("reminder-title-input-message");
    var title = jQuery("#reminder-title").val();
    if (!title) {
        title = "Take Everly Wellness Vitamins";
    }
    var time = jQuery("#reminder-time").val();
    var start = new Date(time);
    var end = new Date(start.getTime() + 600000);
    var now = new Date();
    var filename = "Everly-Wellness-Vitamin-Reminder";

    if (input && input_message && title.length < 1) {
        input.addClass("is-error");
        input_message.innerHTML = "Please enter a name for your reminder";
        return;
    } else if (input && input_message) {
        input.removeClass("is-error");
        input_message.innerHTML = "";
    }

    if (isSafariIOS()) {
        var iCalendarData = [
            "BEGIN:VCALENDAR",
            "CALSCALE:GREGORIAN",
            "PRODID:-//Everly Wellness//Reminder//EN",
            "VERSION:2.0",
            "BEGIN:VEVENT",
            "RRULE:FREQ=DAILY;INTERVAL=1",
            // 'DTSTAMP:20200625T183939',
            // 'DTSTART:20200628T070000',
            // 'DTEND:20200628T071010',
            "DTSTAMP:" + formatDateForIcs(now),
            "DTSTART:" + formatDateForIcs(start),
            "DTEND:" + formatDateForIcs(end),
            "SUMMARY:" + title,
            "UID:4088E990AD89VW3DBB484909",
            "END:VEVENT",
            "END:VCALENDAR",
        ].join("\n");
        var blob = new Blob([iCalendarData], {
            type: "text/calendar",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename + ".ics";
        link.click();
    } else if (isIOS()) {
        // Chrome iOS
        var icsLink = document.createElement("a");
        icsLink.style.display = "none";
        var webcal_title = encodeURI(title);
        var webcal_start = encodeURI(start.getTime()); // 00:00:00
        var webcal_url =
            "webcal://" +
            hostname +
            "/?calreminder=" +
            webcal_title +
            "&start=" +
            webcal_start;
        // console.log("webcal_url", webcal_url);
        icsLink.href = webcal_url;
        document.body.appendChild(icsLink);
        icsLink.click();
        document.body.removeChild(icsLink);
    } else {
        var cal = ics();
        cal.addEvent(title, "", "", start, end, {
            rrule: "RRULE:FREQ=DAILY;INTERVAL=1",
        });
        cal.download(filename);
    }

    if (typeof dataLayer !== "undefined") {
        dataLayer.push({
            event: "custom-event",
            customEventCategory: "reminder",
            customEventAction: "click-add-reminder",
            customEventLabel: null,
            customEventValue: null,
        });
    }

    if (typeof _cio !== "undefined") {
        _cio.track("vitamin_reminder_clicked");
    }
}

export default CalendarReminder;



// WEBPACK FOOTER //
// ./js/components/calendar-reminder/index.js